import { useState } from 'react'
import { AccountRecord, useUpdateAutoFetchContentMutation } from '../../api/client'
import { toastError } from '../../components/Notification'
import Toggle from './Toggle'

/**
 * The account's `fetchContent` switch: its current value, and a toggle that
 * saves it and puts it back if the save fails.
 */
export const useAutoFetchContent = (account: AccountRecord) => {
    const [updateAutoFetchContent, { loading }] = useUpdateAutoFetchContentMutation()

    const [enabled, setEnabled] = useState(account.fetchContent)

    const onToggle = async (isEnabled: boolean) => {
        const previous = enabled
        setEnabled(isEnabled)

        try {
            await updateAutoFetchContent({
                variables: { accountId: account.id, autoFetchContent: isEnabled }
            })
        } catch (err: any) {
            // Catch toggle failure and revert to previous value.
            setEnabled(previous)
            console.error(err)
            toastError(err.message)
        }
    }

    return { enabled, loading, onToggle }
}

const AutoFetchContentApiToggle = ({
    account,
    size,
    tooltip
}: {
    account: AccountRecord
    size: 'small' | 'medium' | 'large'
    tooltip: string
}) => {
    const { enabled, loading, onToggle } = useAutoFetchContent(account)

    return (
        <Toggle
            id={`auto-fetch-${account.id.toString()}`}
            disabled={false}
            checked={enabled}
            label="Fetch with API"
            loading={loading}
            onToggle={onToggle}
            tooltip={tooltip}
            size={size}
        />
    )
}

export default AutoFetchContentApiToggle
